// =============================================================================================
// Foundation Abide Validation
// =============================================================================================

function checkboxValidator(
  $el,      /* jQuery element to validate */
  required, /* is the element required according to the `[required]` attribute */
  parent    /* parent of the jQuery element `$el` */
) {
  const group = parent.closest('.checkbox-group');
  const min = parseInt(group.attr('data-abide-validator-min'), 10);
  const checked = group.find(':checked').length;
  if (checked >= min) {
    // clear label highlight
    group.find('label').each(function() {
     this.classList.remove('is-invalid-label');
    });
    // clear checkbox error
    group.find(':checkbox').each(function() {
     $(this).removeClass('is-invalid-input').removeAttr('data-invalid');
    });
    group.find('.form-error').hide();
    return true;
  }
  else {
    group.find('.form-error').show();
    return false;
  }
}

// Set defaults for form validation (Abide)
Foundation.Abide.defaults.validators['require-checkbox'] = checkboxValidator;
Foundation.Abide.defaults.patterns['minlength'] = /^(.){6,}$/;
Foundation.Abide.defaults.patterns['phone-number'] = /^[0-9\-\+\(\)\s]*$/;

// Set defaults for carousels (Orbit)
Foundation.Orbit.defaults.timerDelay = 4500;

// Initialize Foundation
$(document).foundation();

// =============================================================================================
// Orbit: Resume autoplay on mouse leave
// =============================================================================================
// Foundation's internal pause-on-hover uses mouseover/mouseout on .orbit-wrapper, which fires
// on every child element transition, not just the outer boundary. This can leave the timer
// stuck in a paused state after the mouse leaves. Binding mouseleave on the outer [data-orbit]
// element (which only fires on actual exit) forces the timer to restart reliably.
$('[data-orbit]').each(function() {
  const $orbit = $(this);
  $orbit.on('mouseleave', () => {
    const plugin = $orbit.data('zfPlugin');
    if (plugin && plugin.options.autoPlay && plugin.timer) {
      plugin.timer.restart();
    }
  });
});

// =============================================================================================
// Add Flex Video to YouTube, Vimeo
// =============================================================================================
$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
  if ( this.offsetWidth / this.offsetHeight > 1.5 ) {
    $(this).wrap(`<div class='widescreen responsive-embed'/>`);
  }
  else {
    $(this).wrap(`<div class='responsive-embed'/>`);
  }
});

$('iframe[src*="google.com"]').each(function() {
  $(this).wrap(`<div class='responsive-embed'/>`);
});

// =============================================================================================
// Venue Select Menu
// =============================================================================================

$('#venue-list').on('change', function() {
  const url = this.value;
  if (url !== '') {
    window.location.href = url;
  }
})

// =============================================================================================
// QR Code
// =============================================================================================

if ($('#qrcode').length) {
  $('#qrcode').append(qrcode);
}

// =============================================================================================
// Partner genre filter
// =============================================================================================

$('#partner-genre').on('change', function() {
  const genre = this.value;
  const $partners = $('.partner-grid .partner-filter');
  $partners.removeClass('disabled');

  $partners.each(function() {
    if ( genre && !this.classList.contains(genre) ) {
      this.classList.add('disabled');
    }
  });

})

// =============================================================================================
//	Form Value Check
// =============================================================================================

const options = {
  url: '/account/schools',
  list: {
    maxNumberOfElements: 10,
    match: {
      enabled: true
    }
  }
};

$('input#field-school').easyAutocomplete(options);

$('#field-email').on('blur', checkEmail);
$('#birthdate-select select').on('change', checkBirthdate);
$('input#field-language-other').on('change', checkLanguage);
$('input[name="fields[userDemoGender][]"]').on('change', checkGender);

function checkBirthdate() {
  const [month, day, year] = ['birth-month', 'birth-day', 'birth-year']
    .map(n => $(`#birthdate-select select[name="${n}"]`).val());
  if (month && day && year) {
    $('#field-birthdate').val(`${month}/${day}/${year}`);
  }
}

function checkEmail() {
  fetch(`/account/emailcheck/${this.value}`)
    .then(r => r.text())
    .then(data => {
      const isDuplicate = data.trim() === '1';
      $('#register-email .duplicate-error').toggleClass('hide', !isDuplicate);
    });
}

function checkLanguage() {
  $('#field-language-custom-input').toggleClass('show', this.checked);
}

function checkGender() {
  $('#field-gender-custom-input').toggleClass('show', this.value === 'custom');
}

// =============================================================================================
//	Monthly Calendar
// =============================================================================================

if ($('#calFilters').length) {

  const urlParams = new URLSearchParams(window.location.search);

  ['genre', 'cat', 'partner', 'venue'].forEach(param => {
    const value = urlParams.get(param) || '';
    if (value) {
      $(`#calFilters select[name="${param}"]`).val(value).change().addClass('selected');
    }
  });

}

$('#calFilters select, #calFilters input').on('change', function() {
  this.classList.toggle('selected', !!this.value);
  const params = new URLSearchParams(new FormData(document.getElementById('calFilters')));
  for (const [key, value] of [...params.entries()]) {
    if (!value) params.delete(key);
  }
  window.location.href = `${window.location.pathname}${params.size? '?' + params : ''}`;
})

$('#calPicker td.calendar-pad').on('click', function() {

  $('#calPicker td').removeClass('active');
  this.classList.add('active');

  const site = $(this).data('site');
  const date = $(this).data('date');
  const dateLabel = $(this).data('date-label');
  const eventCount = $(this).data('event-count');

  const hashes = window.location.search.slice(1);

  const url = hashes
    ? `/api/events-filtered.json?site=${site}&date=${date}&${hashes}`
    : `/api/events-date.json?site=${site}&date=${date}`;

  $('#calEvents #calEventsDate').text(dateLabel);
  $('#calEvents #calEventsCount').text(`${eventCount} event${eventCount !== 1? 's' : ''}`);
  $('#calEventsListings').addClass('loading');

  fetch(url)
    .then(r => r.json())
    .then(data => {
      const events = data.data;
      const allDay = events.filter(event => !!event.allDay);
      const notAllDay = events.filter(event => !event.allDay);

      allDay.sort((x, y) => x.title.localeCompare(y.title));

      const $calList = $('#calList').empty();

      notAllDay.forEach(event => {
        if (date === event.startDate) {
          appendEvent($calList, event, event.startTime);
        }
      });

      allDay.forEach(event => appendEvent($calList, event, 'All Day'));

      $('#calEventsListings').removeClass('loading');

    });

})

function appendEvent($list, event, time) {
  if (!event.enabled) return;
  const venue = event.venue.length? event.venue[0].title : '';
  const isFree = event.category.some(e => e.id === 63);
  $list.append(dataBindEvent(time, isFree, event.title, event.slug, venue));
}

function dataBindEvent(time, isFree, title, slug, venue) {
  const template = document.getElementById('cal-event-item');
  const item = template.content.cloneNode(true);
  const eventUrlPrefix = template.dataset.eventUrlPrefix;

  item.querySelector('[data-field="time"]').textContent = time;

  const freePill = item.querySelector('[data-field="free"]');
  if (!isFree) {
    freePill.remove();
  }

  const eventLink = item.querySelector('[data-field="event-link"]');
  eventLink.textContent = title;
  eventLink.href = `${eventUrlPrefix}${slug}`;

  const venueSpan = item.querySelector('[data-field="venue"]');
  if (venue) {
    venueSpan.textContent = venue;
  }
  else {
    venueSpan.remove();
  }

  return item;
}

// =============================================================================================
// Event Check-In
// =============================================================================================

$('#form-checkin input:radio[name="showtimes"]').on('change', function() {

  const showtime = this.value;

  const backingField = $('#field-showtime');
  const unlistedField = $('#field-showtimes-unlisted-options');
  const unlistedBackingField = $('#field-showtime-unlisted');
  const isUnlisted = showtime === 'unlisted';

  backingField.val(isUnlisted? unlistedField.val() : showtime);
  unlistedBackingField.val(isUnlisted? '1' : '0');

  unlistedField.toggleClass('disabled', !isUnlisted);
  unlistedField.prop('disabled', !isUnlisted);
  unlistedField.prop('required', isUnlisted);
  unlistedField.toggle(isUnlisted);

})

$('#form-checkin #field-showtimes-unlisted-options').on('change', function() {
  $('#field-showtime').val(this.value);
})

$('#form-checkin #field-guest-count').on('change', function() {
  const guestCount = Number(this.value);
  const guestTypes = $('#checkin-guest-types');
  const guestTypesList = $('#checkin-guest-types .checkbox-group')
  guestTypes.toggle(guestCount > 0);
  guestTypesList.attr('data-abide-validator-min', guestCount > 0? '1' : '0');
})

$('a[href^="http"]').each(function() {
  if (this.hostname !== location.hostname) {
    this.setAttribute('target', '_blank');
  }
});